export const teacherFormItems = [
  {
    field: 'ruleValue',
    label: '规则',
    type: 'input',
    prop: 'ruleValue',
    rules: { required: true, message: '请输入规则', trigger: 'change' }
  },
  {
    field: 'ruleType',
    label: '配置类型',
    type: 'select',
    prop: 'ruleType',
    rules: { required: true, message: '请选择配置类型', trigger: 'change' },
    options: {
      select: [
        {label: '个人', value: 1},
        {label: '部门', value: 2},
        {label: '指定部门', value: 3},
      ]
    }
  }
]

export const weChatformItems = [
  {
    field: 'roomName',
    label: '名称',
    type: 'input',
    prop: 'roomName',
    rules: { required: true, message: '名称', trigger: 'change' }
  },
  {
    field: 'roomId',
    label: '视频ID',
    type: 'input',
    prop: 'roomId',
    rules: { required: true, message: '视频ID', trigger: 'change' }
  }
]

export const smsTmptFormItems = [
  {
    field: 'templateId',
    label: '模版ID',
    type: 'input',
    prop: 'templateId',
    inputConf: {
      disabled: false,
      maxlength: 26,
    },
    rules: [
      { required: true, message: '请输入模版ID', trigger: 'blur' },
      { pattern: /^[A-Za-z0-9_]{1,}$/, message: "只能输入英文数字下划线" },
    ]
  },
  {
    field: 'content',
    label: '模版内容',
    type: 'textarea',
    prop: 'content',
    inputConf: {
      disabled: false,
      maxlength: 184
    },
    rules: [
      { required: true, message: '请输入模版内容', trigger: 'blur' },
    ]
  },
  {
    field: 'smsTheme',
    label: '模版主题',
    type: 'input',
    prop: 'smsTheme',
    inputConf: {
      disabled: false,
      maxlength: 26,
    },
    rules: [
      { required: true, message: '请输入请输入模版主题', trigger: 'blur' },
    ]
  },
  {
    field: 'boolSignChoose',
    label: '是否支持商家选择',
    type: 'radio',
    prop: 'boolSignChoose',
    options: {
      select: [
        {label: '1', name: '是'},
        {label: '0', name: '否'},
      ]
    }
  }
]
export const dictionariesFormItems = [
  {
    field: 'sortNo',
    label: '排序号',
    type: 'int',
    prop: 'sortNo',
    inputConf: {
      disabled: false,
      maxlength: 8,
    },
    rules: [
      { required: true, message: '请输入排序号', trigger: 'blur' },
    ]
  },
  {
    field: 'typeCode',
    label: '类型编码',
    type: 'input',
    prop: 'typeCode',
    inputConf: {
      disabled: false,
      maxlength: 64,
    },
    rules: [
      { required: true, message: '请输入类型编码', trigger: 'blur' },
      {
        pattern: /^[A-Za-z0-9_]{1,}$/,
        message: "只能输入英文数字下划线",
      },
    ]
  },
  {
    field: 'typeName',
    label: '类型名称',
    type: 'input',
    prop: 'typeName',
    inputConf: {
      maxlength: 80,
    },
    rules: [
      { required: true, message: '请输入类型名称', trigger: 'blur' },
    ]
  },
  {
    field: 'describe',
    label: '描述',
    type: 'textarea',
    prop: 'describe',
    inputConf: {
      maxlength: 512,
    },
    rules: [
      { required: true, message: '请输入请输入描述', trigger: 'blur' },
    ]
  }
]
export const dictDetailsFormItems = [
  {
    field: 'sortNo',
    label: '排序号',
    type: 'int',
    prop: 'sortNo',
    inputConf: {
      disabled: false,
      maxlength: 8,
    },
    rules: [
      { required: true, message: '请输入排序号', trigger: 'blur' },
    ]
  },
  {
    field: 'typeCode',
    label: '关联字典',
    type: 'input',
    prop: 'typeCode',
    inputConf: {
      disabled: true,
    },
  },
  {
    field: 'dictDataCode',
    label: '数据编码',
    type: 'input',
    prop: 'dictDataCode',
    inputConf: {
      maxlength: 64,
    },
    rules: [
      { required: true, message: '请输入数据编码', trigger: 'blur' },
      {
        pattern: /^[A-Za-z0-9_]{1,}$/,
        message: "只能输入英文数字下划线",
      },
    ]
  },
  {
    field: 'dictDataValue',
    label: '数据值',
    type: 'textarea',
    prop: 'dictDataValue',
    inputConf: {
      maxlength: 512,
    },
    rules: [
      { required: true, message: '请输入数据值', trigger: 'blur' },
    ]
  },
  {
    field: 'extendField',
    label: '拓展字段',
    type: 'textarea',
    prop: 'extendField',
    inputConf: {
      maxlength: 400,
    }
  },
  {
    field: 'dataDesc',
    label: '数据描述',
    type: 'textarea',
    prop: 'dataDesc',
    inputConf: {
      maxlength: 400,
    },
    rules: [
      { required: true, message: '请输入请输入描述', trigger: 'blur' },
    ]
  }
]
export const tokenFormItems = [
  {
    field: 'uid',
    label: 'uniID',
    prop: 'uid',
    rules: [
      { required: true, message: '请输入uid', trigger: 'blur' },
    ]
  },
]

